/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ArticlePastSearchContractResponse,
    ArticlePastSearchContractResponseFromJSON,
    ArticlePastSearchContractResponseToJSON,
    BadRequestResponse,
    BadRequestResponseFromJSON,
    BadRequestResponseToJSON,
    ConflictResponse,
    ConflictResponseFromJSON,
    ConflictResponseToJSON,
    GetClipIsBulkBillingCompanyResponse,
    GetClipIsBulkBillingCompanyResponseFromJSON,
    GetClipIsBulkBillingCompanyResponseToJSON,
    GetFirstClipResponse,
    GetFirstClipResponseFromJSON,
    GetFirstClipResponseToJSON,
    GetFreeTrialResponse,
    GetFreeTrialResponseFromJSON,
    GetFreeTrialResponseToJSON,
    GetIsApplyingSportTimesProgramResponse,
    GetIsApplyingSportTimesProgramResponseFromJSON,
    GetIsApplyingSportTimesProgramResponseToJSON,
    GoneResponse,
    GoneResponseFromJSON,
    GoneResponseToJSON,
    InternalServerErrorResponse,
    InternalServerErrorResponseFromJSON,
    InternalServerErrorResponseToJSON,
    NotFoundResponse,
    NotFoundResponseFromJSON,
    NotFoundResponseToJSON,
    PostClippingPastArticleResearchBillingBody,
    PostClippingPastArticleResearchBillingBodyFromJSON,
    PostClippingPastArticleResearchBillingBodyToJSON,
    PostClippingPastArticleResearchBillingSuccessResponse,
    PostClippingPastArticleResearchBillingSuccessResponseFromJSON,
    PostClippingPastArticleResearchBillingSuccessResponseToJSON,
    PostClippingResearchBillingBody,
    PostClippingResearchBillingBodyFromJSON,
    PostClippingResearchBillingBodyToJSON,
    PostClippingResearchBillingSuccessResponse,
    PostClippingResearchBillingSuccessResponseFromJSON,
    PostClippingResearchBillingSuccessResponseToJSON,
    PostFreeTrialBody,
    PostFreeTrialBodyFromJSON,
    PostFreeTrialBodyToJSON,
    PostFreeTrialSuccessResponse,
    PostFreeTrialSuccessResponseFromJSON,
    PostFreeTrialSuccessResponseToJSON,
    PostRegisterFirstClipBody,
    PostRegisterFirstClipBodyFromJSON,
    PostRegisterFirstClipBodyToJSON,
    PostRegisterFirstClipSuccessResponse,
    PostRegisterFirstClipSuccessResponseFromJSON,
    PostRegisterFirstClipSuccessResponseToJSON,
} from '../models';

export interface ApplyFreeTrialRequest {
    authenticationToken: string;
    postFreeTrialBody?: PostFreeTrialBody;
}

export interface CreateClippingPastArticleSearchRequest {
    authenticationToken: string;
    postClippingPastArticleResearchBillingBody?: PostClippingPastArticleResearchBillingBody;
}

export interface CreateClippingResearchBillingRequest {
    authenticationToken: string;
    postClippingResearchBillingBody?: PostClippingResearchBillingBody;
}

export interface GetAlreadyCreatedFirstClipFromBackendRequest {
    companyId: number;
    authenticationToken: string;
}

export interface GetBackendIsBulkBillingCompanyByCompanyIdRequest {
    companyId: number;
}

export interface GetFreeTrialInfoFromBackendRequest {
    companyId: number;
    authenticationToken: string;
}

export interface GetIsApplyingSportsTimesProgramFromBackendRequest {
    companyId: number;
    authenticationToken: string;
}

export interface RegisterFirstClipRequest {
    authenticationToken: string;
    postRegisterFirstClipBody?: PostRegisterFirstClipBody;
}

/**
 * 
 */
export class ClippingBillingApi extends runtime.BaseAPI {

    /**
     * 無料トライアルを適用する
     * Apply free trial for company
     */
    async applyFreeTrialRaw(requestParameters: ApplyFreeTrialRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostFreeTrialSuccessResponse>> {
        if (requestParameters.authenticationToken === null || requestParameters.authenticationToken === undefined) {
            throw new runtime.RequiredError('authenticationToken','Required parameter requestParameters.authenticationToken was null or undefined when calling applyFreeTrial.');
        }

        const queryParameters: any = {};

        if (requestParameters.authenticationToken !== undefined) {
            queryParameters['authentication_token'] = requestParameters.authenticationToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/free_trial`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostFreeTrialBodyToJSON(requestParameters.postFreeTrialBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFreeTrialSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 無料トライアルを適用する
     * Apply free trial for company
     */
    async applyFreeTrial(requestParameters: ApplyFreeTrialRequest, initOverrides?: RequestInit): Promise<PostFreeTrialSuccessResponse> {
        const response = await this.applyFreeTrialRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * クリッピング過去記事検索の請求を発生させる
     * Create clipping past article search billing
     */
    async createClippingPastArticleSearchRaw(requestParameters: CreateClippingPastArticleSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostClippingPastArticleResearchBillingSuccessResponse>> {
        if (requestParameters.authenticationToken === null || requestParameters.authenticationToken === undefined) {
            throw new runtime.RequiredError('authenticationToken','Required parameter requestParameters.authenticationToken was null or undefined when calling createClippingPastArticleSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.authenticationToken !== undefined) {
            queryParameters['authentication_token'] = requestParameters.authenticationToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing/past_article_search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostClippingPastArticleResearchBillingBodyToJSON(requestParameters.postClippingPastArticleResearchBillingBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostClippingPastArticleResearchBillingSuccessResponseFromJSON(jsonValue));
    }

    /**
     * クリッピング過去記事検索の請求を発生させる
     * Create clipping past article search billing
     */
    async createClippingPastArticleSearch(requestParameters: CreateClippingPastArticleSearchRequest, initOverrides?: RequestInit): Promise<PostClippingPastArticleResearchBillingSuccessResponse> {
        const response = await this.createClippingPastArticleSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * クリッピング調査の請求を発生させる
     * Create clipping research billing
     */
    async createClippingResearchBillingRaw(requestParameters: CreateClippingResearchBillingRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostClippingResearchBillingSuccessResponse>> {
        if (requestParameters.authenticationToken === null || requestParameters.authenticationToken === undefined) {
            throw new runtime.RequiredError('authenticationToken','Required parameter requestParameters.authenticationToken was null or undefined when calling createClippingResearchBilling.');
        }

        const queryParameters: any = {};

        if (requestParameters.authenticationToken !== undefined) {
            queryParameters['authentication_token'] = requestParameters.authenticationToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing/research`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostClippingResearchBillingBodyToJSON(requestParameters.postClippingResearchBillingBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostClippingResearchBillingSuccessResponseFromJSON(jsonValue));
    }

    /**
     * クリッピング調査の請求を発生させる
     * Create clipping research billing
     */
    async createClippingResearchBilling(requestParameters: CreateClippingResearchBillingRequest, initOverrides?: RequestInit): Promise<PostClippingResearchBillingSuccessResponse> {
        const response = await this.createClippingResearchBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 初回クリップ作成済みかバックエンドから確認する
     * Get already created first clip from backend
     */
    async getAlreadyCreatedFirstClipFromBackendRaw(requestParameters: GetAlreadyCreatedFirstClipFromBackendRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetFirstClipResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getAlreadyCreatedFirstClipFromBackend.');
        }

        if (requestParameters.authenticationToken === null || requestParameters.authenticationToken === undefined) {
            throw new runtime.RequiredError('authenticationToken','Required parameter requestParameters.authenticationToken was null or undefined when calling getAlreadyCreatedFirstClipFromBackend.');
        }

        const queryParameters: any = {};

        if (requestParameters.authenticationToken !== undefined) {
            queryParameters['authentication_token'] = requestParameters.authenticationToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/backend/first_clip/company/{company_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFirstClipResponseFromJSON(jsonValue));
    }

    /**
     * 初回クリップ作成済みかバックエンドから確認する
     * Get already created first clip from backend
     */
    async getAlreadyCreatedFirstClipFromBackend(requestParameters: GetAlreadyCreatedFirstClipFromBackendRequest, initOverrides?: RequestInit): Promise<GetFirstClipResponse> {
        const response = await this.getAlreadyCreatedFirstClipFromBackendRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 初回クリップ作成済みかフロントエンドから確認する
     * Get already created first clip from frontend
     */
    async getAlreadyCreatedFirstClipFromFrontendRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetFirstClipResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/frontend/first_clip/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFirstClipResponseFromJSON(jsonValue));
    }

    /**
     * 初回クリップ作成済みかフロントエンドから確認する
     * Get already created first clip from frontend
     */
    async getAlreadyCreatedFirstClipFromFrontend(initOverrides?: RequestInit): Promise<GetFirstClipResponse> {
        const response = await this.getAlreadyCreatedFirstClipFromFrontendRaw(initOverrides);
        return await response.value();
    }

    /**
     * 過去記事検索の契約情報を取得するAPI
     * 過去記事検索の契約情報を取得する
     */
    async getArticlePastSearchContractRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticlePastSearchContractResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/article/past_search/contract`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticlePastSearchContractResponseFromJSON(jsonValue));
    }

    /**
     * 過去記事検索の契約情報を取得するAPI
     * 過去記事検索の契約情報を取得する
     */
    async getArticlePastSearchContract(initOverrides?: RequestInit): Promise<ArticlePastSearchContractResponse> {
        const response = await this.getArticlePastSearchContractRaw(initOverrides);
        return await response.value();
    }

    /**
     * 企業に一括請求が適用されているかバックエンドから判定するAPI
     * 企業に一括請求が適用されているかバックエンドから判定するAPI
     */
    async getBackendIsBulkBillingCompanyByCompanyIdRaw(requestParameters: GetBackendIsBulkBillingCompanyByCompanyIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetClipIsBulkBillingCompanyResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getBackendIsBulkBillingCompanyByCompanyId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/backend/clip/is_bulk_billing/company/{company_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClipIsBulkBillingCompanyResponseFromJSON(jsonValue));
    }

    /**
     * 企業に一括請求が適用されているかバックエンドから判定するAPI
     * 企業に一括請求が適用されているかバックエンドから判定するAPI
     */
    async getBackendIsBulkBillingCompanyByCompanyId(requestParameters: GetBackendIsBulkBillingCompanyByCompanyIdRequest, initOverrides?: RequestInit): Promise<GetClipIsBulkBillingCompanyResponse> {
        const response = await this.getBackendIsBulkBillingCompanyByCompanyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の企業が無料トライアルを適用しているかバックエンドから確認する
     * Get free trial info from backend
     */
    async getFreeTrialInfoFromBackendRaw(requestParameters: GetFreeTrialInfoFromBackendRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetFreeTrialResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getFreeTrialInfoFromBackend.');
        }

        if (requestParameters.authenticationToken === null || requestParameters.authenticationToken === undefined) {
            throw new runtime.RequiredError('authenticationToken','Required parameter requestParameters.authenticationToken was null or undefined when calling getFreeTrialInfoFromBackend.');
        }

        const queryParameters: any = {};

        if (requestParameters.authenticationToken !== undefined) {
            queryParameters['authentication_token'] = requestParameters.authenticationToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/backend/free_trial/company/{company_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFreeTrialResponseFromJSON(jsonValue));
    }

    /**
     * 特定の企業が無料トライアルを適用しているかバックエンドから確認する
     * Get free trial info from backend
     */
    async getFreeTrialInfoFromBackend(requestParameters: GetFreeTrialInfoFromBackendRequest, initOverrides?: RequestInit): Promise<GetFreeTrialResponse> {
        const response = await this.getFreeTrialInfoFromBackendRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の企業が無料トライアルを適用しているかフロントエンドから確認する
     * Get free trial info from frontend
     */
    async getFreeTrialInfoFromFrontendRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetFreeTrialResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/frontend/free_trial/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFreeTrialResponseFromJSON(jsonValue));
    }

    /**
     * 特定の企業が無料トライアルを適用しているかフロントエンドから確認する
     * Get free trial info from frontend
     */
    async getFreeTrialInfoFromFrontend(initOverrides?: RequestInit): Promise<GetFreeTrialResponse> {
        const response = await this.getFreeTrialInfoFromFrontendRaw(initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーにSPORTS TIMESプログラムが適用されているか判定するAPI
     * ログインしている企業ユーザーにSPORTS TIMESプログラムが適用されているか判定するAPI
     */
    async getIsApplyingSportsTimesProgramRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetIsApplyingSportTimesProgramResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/me/is_applying_sports_times_program`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIsApplyingSportTimesProgramResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーにSPORTS TIMESプログラムが適用されているか判定するAPI
     * ログインしている企業ユーザーにSPORTS TIMESプログラムが適用されているか判定するAPI
     */
    async getIsApplyingSportsTimesProgram(initOverrides?: RequestInit): Promise<GetIsApplyingSportTimesProgramResponse> {
        const response = await this.getIsApplyingSportsTimesProgramRaw(initOverrides);
        return await response.value();
    }

    /**
     * 企業にSPORTS TIMESプログラムが適用されているかバックエンドから判定するAPI
     * 企業にSPORTS TIMESプログラムが適用されているかバックエンドから判定するAPI
     */
    async getIsApplyingSportsTimesProgramFromBackendRaw(requestParameters: GetIsApplyingSportsTimesProgramFromBackendRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetIsApplyingSportTimesProgramResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getIsApplyingSportsTimesProgramFromBackend.');
        }

        if (requestParameters.authenticationToken === null || requestParameters.authenticationToken === undefined) {
            throw new runtime.RequiredError('authenticationToken','Required parameter requestParameters.authenticationToken was null or undefined when calling getIsApplyingSportsTimesProgramFromBackend.');
        }

        const queryParameters: any = {};

        if (requestParameters.authenticationToken !== undefined) {
            queryParameters['authentication_token'] = requestParameters.authenticationToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/backend/is_applying_sports_times_program/company/{company_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIsApplyingSportTimesProgramResponseFromJSON(jsonValue));
    }

    /**
     * 企業にSPORTS TIMESプログラムが適用されているかバックエンドから判定するAPI
     * 企業にSPORTS TIMESプログラムが適用されているかバックエンドから判定するAPI
     */
    async getIsApplyingSportsTimesProgramFromBackend(requestParameters: GetIsApplyingSportsTimesProgramFromBackendRequest, initOverrides?: RequestInit): Promise<GetIsApplyingSportTimesProgramResponse> {
        const response = await this.getIsApplyingSportsTimesProgramFromBackendRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 初回クリップとして登録する
     * Register as the first clip
     */
    async registerFirstClipRaw(requestParameters: RegisterFirstClipRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostRegisterFirstClipSuccessResponse>> {
        if (requestParameters.authenticationToken === null || requestParameters.authenticationToken === undefined) {
            throw new runtime.RequiredError('authenticationToken','Required parameter requestParameters.authenticationToken was null or undefined when calling registerFirstClip.');
        }

        const queryParameters: any = {};

        if (requestParameters.authenticationToken !== undefined) {
            queryParameters['authentication_token'] = requestParameters.authenticationToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/first_clip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostRegisterFirstClipBodyToJSON(requestParameters.postRegisterFirstClipBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostRegisterFirstClipSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 初回クリップとして登録する
     * Register as the first clip
     */
    async registerFirstClip(requestParameters: RegisterFirstClipRequest, initOverrides?: RequestInit): Promise<PostRegisterFirstClipSuccessResponse> {
        const response = await this.registerFirstClipRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
